import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-cinema-dark">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white">
            电影分类
          </h2>
          <p className="text-cinema-text-dim text-sm mt-2">按类别浏览，快速找到你想看的电影</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat, index) => (
            <Link
              key={cat.key}
              to={`/category/${cat.key}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-lg bg-cinema-card border border-cinema-border hover:border-cinema-gold/40 transition-all duration-300 hover:bg-cinema-card/80 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-cinema-gold/10 text-cinema-gold group-hover:bg-cinema-gold group-hover:text-cinema-black transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-white text-sm font-medium group-hover:text-cinema-gold transition-colors whitespace-nowrap">
                {cat.label}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}